import { useAuthRedirect } from '#hooks/useAuthRedirect';
import { Helmet } from 'react-helmet-async';
import * as S from './styles';

import { LandingTop } from './LandingTop';
import { LandingTopContent } from './LandingTopContent';
import { LandingSection } from './LandingSection';
import { useNavigate } from 'react-router';
import LandingFooter from './LandingFooter';
export const LandingPageV2 = () => {
  const isLoading = useAuthRedirect();
  const navigate = useNavigate();

  if (isLoading) {
    return null;
  }
  return (
    <S.Container>
      <Helmet>
        <title>피벗 for 트레이너</title>
        <meta
          name="title"
          content="피벗 for 트레이너 - 상위 1% 트레이너들의 회원 관리 방법"
        />
        <meta
          name="description"
          content="재등록 매출부터 신규 매출까지 오르는 회원, 수업, 운동 일지 관리 서비스."
        />
        <meta property="og:title" content="피벗 for 트레이너" />
        <meta
          property="og:description"
          content="상위 1% 트레이너들의 회원 관리 방법"
        />
        <meta name="robots" content="index,nofollow" />
      </Helmet>
      <LandingTop />
      <LandingTopContent />
      <LandingSection />
      <LandingFooter />
      <S.ButtonBox>
        <S.Button onClick={() => navigate('/home')}>피벗 시작하기</S.Button>
      </S.ButtonBox>
    </S.Container>
  );
};
